module.exports = __webpack_public_path__ + "media/audio5.42494e7a.mp4";